import { render } from "./neworder.vue?vue&type=template&id=389d52df"
import script from "./neworder.vue?vue&type=script&lang=js"
export * from "./neworder.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tommygrimm/PhpstormProjects/holcimsgeportal.20north.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__